import { isServer } from './helpers';

export async function getPlaceholderImage(src: string) {
  if (!isServer()) {
    return null;
  }
  try {
    const { getPlaiceholder } = await import('plaiceholder');
    const buffer = await fetch(src).then(async res =>
      Buffer.from(await res.arrayBuffer())
    );
    return await getPlaiceholder(buffer);
  } catch (error) {
    return null;
  }
}

export async function getPlaceholderDataUrl(imageUrl: string): Promise<string> {
  try {
    const imageUrlParts = imageUrl.split('?');
    const queryString = imageUrlParts[1] || '';
    const urlWithParams = `${imageUrlParts[0]}?${queryString}&width=100&fit=inside&withoutEnlargement=true&format=webp`;
    if (isServer()) {
      const backendUrlWithParams = urlWithParams.replace(
        process.env.NEXT_PUBLIC_BACKEND_BASE_URL || '',
        process.env.BACKEND_BASE_URL || ''
      );
      const placeholder = await getPlaceholderImage(backendUrlWithParams);
      return placeholder?.base64 || '';
    } else {
      const response = await fetch(urlWithParams);
      const blob = await response.blob();
      return new Promise(resolve => {
        const reader = new FileReader();
        reader.onloadend = () => {
          const base64String = reader.result as string;
          resolve(base64String);
        };
        reader.onerror = () => resolve('');
        reader.readAsDataURL(blob);
      });
    }
  } catch (error) {
    return '';
  }
}

export function isGIF(mimeType?: string | null) {
  if (!mimeType) {
    return false;
  }
  return mimeType.startsWith('image/gif');
}
